/** Country list for club-admin DigiPing registration (same catalog as player). */

export const CLUB_ADMIN_COUNTRIES = [
        // Europe
        { id: 'AD', name: 'Andorra', code: 'AD', flag: '🇦🇩' },
        { id: 'AL', name: 'Albania', code: 'AL', flag: '🇦🇱' },
        { id: 'AT', name: 'Austria', code: 'AT', flag: '🇦🇹' },
        { id: 'BA', name: 'Bosnia and Herzegovina', code: 'BA', flag: '🇧🇦' },
        { id: 'BE', name: 'Belgium', code: 'BE', flag: '🇧🇪' },
        { id: 'BG', name: 'Bulgaria', code: 'BG', flag: '🇧🇬' },
        { id: 'BY', name: 'Belarus', code: 'BY', flag: '🇧🇾' },
        { id: 'CH', name: 'Switzerland', code: 'CH', flag: '🇨🇭' },
        { id: 'CY', name: 'Cyprus', code: 'CY', flag: '🇨🇾' },
        { id: 'CZ', name: 'Czech Republic', code: 'CZ', flag: '🇨🇿' },
        { id: 'DE', name: 'Germany', code: 'DE', flag: '🇩🇪' },
        { id: 'DK', name: 'Denmark', code: 'DK', flag: '🇩🇰' },
        { id: 'EE', name: 'Estonia', code: 'EE', flag: '🇪🇪' },
        { id: 'ES', name: 'Spain', code: 'ES', flag: '🇪🇸' },
        { id: 'FI', name: 'Finland', code: 'FI', flag: '🇫🇮' },
        { id: 'FR', name: 'France', code: 'FR', flag: '🇫🇷' },
        { id: 'GB', name: 'United Kingdom', code: 'GB', flag: '🇬🇧' },
        { id: 'GR', name: 'Greece', code: 'GR', flag: '🇬🇷' },
        { id: 'HR', name: 'Croatia', code: 'HR', flag: '🇭🇷' },
        { id: 'HU', name: 'Hungary', code: 'HU', flag: '🇭🇺' },
        { id: 'IE', name: 'Ireland', code: 'IE', flag: '🇮🇪' },
        { id: 'IS', name: 'Iceland', code: 'IS', flag: '🇮🇸' },
        { id: 'IT', name: 'Italy', code: 'IT', flag: '🇮🇹' },
        { id: 'LI', name: 'Liechtenstein', code: 'LI', flag: '🇱🇮' },
        { id: 'LT', name: 'Lithuania', code: 'LT', flag: '🇱🇹' },
        { id: 'LU', name: 'Luxembourg', code: 'LU', flag: '🇱🇺' },
        { id: 'LV', name: 'Latvia', code: 'LV', flag: '🇱🇻' },
        { id: 'MC', name: 'Monaco', code: 'MC', flag: '🇲🇨' },
        { id: 'MD', name: 'Moldova', code: 'MD', flag: '🇲🇩' },
        { id: 'ME', name: 'Montenegro', code: 'ME', flag: '🇲🇪' },
        { id: 'MK', name: 'North Macedonia', code: 'MK', flag: '🇲🇰' },
        { id: 'MT', name: 'Malta', code: 'MT', flag: '🇲🇹' },
        { id: 'NL', name: 'Netherlands', code: 'NL', flag: '🇳🇱' },
        { id: 'NO', name: 'Norway', code: 'NO', flag: '🇳🇴' },
        { id: 'PL', name: 'Poland', code: 'PL', flag: '🇵🇱' },
        { id: 'PT', name: 'Portugal', code: 'PT', flag: '🇵🇹' },
        { id: 'RO', name: 'Romania', code: 'RO', flag: '🇷🇴' },
        { id: 'RS', name: 'Serbia', code: 'RS', flag: '🇷🇸' },
        { id: 'RU', name: 'Russia', code: 'RU', flag: '🇷🇺' },
        { id: 'SE', name: 'Sweden', code: 'SE', flag: '🇸🇪' },
        { id: 'SI', name: 'Slovenia', code: 'SI', flag: '🇸🇮' },
        { id: 'SK', name: 'Slovakia', code: 'SK', flag: '🇸🇰' },
        { id: 'SM', name: 'San Marino', code: 'SM', flag: '🇸🇲' },
        { id: 'UA', name: 'Ukraine', code: 'UA', flag: '🇺🇦' },
        { id: 'VA', name: 'Vatican City', code: 'VA', flag: '🇻🇦' },
        { id: 'XK', name: 'Kosovo', code: 'XK', flag: '🇽🇰' },

        // North America
        { id: 'US', name: 'United States', code: 'US', flag: '🇺🇸' },
        { id: 'CA', name: 'Canada', code: 'CA', flag: '🇨🇦' },
        { id: 'MX', name: 'Mexico', code: 'MX', flag: '🇲🇽' },
        { id: 'GT', name: 'Guatemala', code: 'GT', flag: '🇬🇹' },
        { id: 'CU', name: 'Cuba', code: 'CU', flag: '🇨🇺' },
        { id: 'JM', name: 'Jamaica', code: 'JM', flag: '🇯🇲' },
        { id: 'HT', name: 'Haiti', code: 'HT', flag: '🇭🇹' },
        { id: 'DO', name: 'Dominican Republic', code: 'DO', flag: '🇩🇴' },
        { id: 'CR', name: 'Costa Rica', code: 'CR', flag: '🇨🇷' },
        { id: 'PA', name: 'Panama', code: 'PA', flag: '🇵🇦' },
        { id: 'NI', name: 'Nicaragua', code: 'NI', flag: '🇳🇮' },
        { id: 'HN', name: 'Honduras', code: 'HN', flag: '🇭🇳' },
        { id: 'SV', name: 'El Salvador', code: 'SV', flag: '🇸🇻' },
        { id: 'BZ', name: 'Belize', code: 'BZ', flag: '🇧🇿' },

        // South America
        { id: 'BR', name: 'Brazil', code: 'BR', flag: '🇧🇷' },
        { id: 'AR', name: 'Argentina', code: 'AR', flag: '🇦🇷' },
        { id: 'CL', name: 'Chile', code: 'CL', flag: '🇨🇱' },
        { id: 'CO', name: 'Colombia', code: 'CO', flag: '🇨🇴' },
        { id: 'PE', name: 'Peru', code: 'PE', flag: '🇵🇪' },
        { id: 'VE', name: 'Venezuela', code: 'VE', flag: '🇻🇪' },
        { id: 'EC', name: 'Ecuador', code: 'EC', flag: '🇪🇨' },
        { id: 'BO', name: 'Bolivia', code: 'BO', flag: '🇧🇴' },
        { id: 'PY', name: 'Paraguay', code: 'PY', flag: '🇵🇾' },
        { id: 'UY', name: 'Uruguay', code: 'UY', flag: '🇺🇾' },
        { id: 'GY', name: 'Guyana', code: 'GY', flag: '🇬🇾' },
        { id: 'SR', name: 'Suriname', code: 'SR', flag: '🇸🇷' },
        { id: 'GF', name: 'French Guiana', code: 'GF', flag: '🇬🇫' },

        // Asia
        { id: 'CN', name: 'China', code: 'CN', flag: '🇨🇳' },
        { id: 'JP', name: 'Japan', code: 'JP', flag: '🇯🇵' },
        { id: 'KR', name: 'South Korea', code: 'KR', flag: '🇰🇷' },
        { id: 'IN', name: 'India', code: 'IN', flag: '🇮🇳' },
        { id: 'ID', name: 'Indonesia', code: 'ID', flag: '🇮🇩' },
        { id: 'TH', name: 'Thailand', code: 'TH', flag: '🇹🇭' },
        { id: 'VN', name: 'Vietnam', code: 'VN', flag: '🇻🇳' },
        { id: 'PH', name: 'Philippines', code: 'PH', flag: '🇵🇭' },
        { id: 'MY', name: 'Malaysia', code: 'MY', flag: '🇲🇾' },
        { id: 'SG', name: 'Singapore', code: 'SG', flag: '🇸🇬' },
        { id: 'HK', name: 'Hong Kong', code: 'HK', flag: '🇭🇰' },
        { id: 'TW', name: 'Taiwan', code: 'TW', flag: '🇹🇼' },
        { id: 'MN', name: 'Mongolia', code: 'MN', flag: '🇲🇳' },
        { id: 'KZ', name: 'Kazakhstan', code: 'KZ', flag: '🇰🇿' },
        { id: 'UZ', name: 'Uzbekistan', code: 'UZ', flag: '🇺🇿' },
        { id: 'KG', name: 'Kyrgyzstan', code: 'KG', flag: '🇰🇬' },
        { id: 'TJ', name: 'Tajikistan', code: 'TJ', flag: '🇹🇯' },
        { id: 'TM', name: 'Turkmenistan', code: 'TM', flag: '🇹🇲' },
        { id: 'AF', name: 'Afghanistan', code: 'AF', flag: '🇦🇫' },
        { id: 'PK', name: 'Pakistan', code: 'PK', flag: '🇵🇰' },
        { id: 'BD', name: 'Bangladesh', code: 'BD', flag: '🇧🇩' },
        { id: 'LK', name: 'Sri Lanka', code: 'LK', flag: '🇱🇰' },
        { id: 'MV', name: 'Maldives', code: 'MV', flag: '🇲🇻' },
        { id: 'BT', name: 'Bhutan', code: 'BT', flag: '🇧🇹' },
        { id: 'NP', name: 'Nepal', code: 'NP', flag: '🇳🇵' },
        { id: 'MM', name: 'Myanmar', code: 'MM', flag: '🇲🇲' },
        { id: 'LA', name: 'Laos', code: 'LA', flag: '🇱🇦' },
        { id: 'KH', name: 'Cambodia', code: 'KH', flag: '🇰🇭' },
        { id: 'BN', name: 'Brunei', code: 'BN', flag: '🇧🇳' },
        { id: 'TL', name: 'East Timor', code: 'TL', flag: '🇹🇱' },

        // Middle East
        { id: 'SA', name: 'Saudi Arabia', code: 'SA', flag: '🇸🇦' },
        { id: 'AE', name: 'United Arab Emirates', code: 'AE', flag: '🇦🇪' },
        { id: 'QA', name: 'Qatar', code: 'QA', flag: '🇶🇦' },
        { id: 'KW', name: 'Kuwait', code: 'KW', flag: '🇰🇼' },
        { id: 'BH', name: 'Bahrain', code: 'BH', flag: '🇧🇭' },
        { id: 'OM', name: 'Oman', code: 'OM', flag: '🇴🇲' },
        { id: 'YE', name: 'Yemen', code: 'YE', flag: '🇾🇪' },
        { id: 'IQ', name: 'Iraq', code: 'IQ', flag: '🇮🇶' },
        { id: 'IR', name: 'Iran', code: 'IR', flag: '🇮🇷' },
        { id: 'SY', name: 'Syria', code: 'SY', flag: '🇸🇾' },
        { id: 'LB', name: 'Lebanon', code: 'LB', flag: '🇱🇧' },
        { id: 'JO', name: 'Jordan', code: 'JO', flag: '🇯🇴' },
        { id: 'IL', name: 'Israel', code: 'IL', flag: '🇮🇱' },
        { id: 'PS', name: 'Palestine', code: 'PS', flag: '🇵🇸' },
        { id: 'TR', name: 'Turkey', code: 'TR', flag: '🇹🇷' },

        // Africa
        { id: 'ZA', name: 'South Africa', code: 'ZA', flag: '🇿🇦' },
        { id: 'NG', name: 'Nigeria', code: 'NG', flag: '🇳🇬' },
        { id: 'EG', name: 'Egypt', code: 'EG', flag: '🇪🇬' },
        { id: 'KE', name: 'Kenya', code: 'KE', flag: '🇰🇪' },
        { id: 'ET', name: 'Ethiopia', code: 'ET', flag: '🇪🇹' },
        { id: 'GH', name: 'Ghana', code: 'GH', flag: '🇬🇭' },
        { id: 'MA', name: 'Morocco', code: 'MA', flag: '🇲🇦' },
        { id: 'TN', name: 'Tunisia', code: 'TN', flag: '🇹🇳' },
        { id: 'DZ', name: 'Algeria', code: 'DZ', flag: '🇩🇿' },
        { id: 'LY', name: 'Libya', code: 'LY', flag: '🇱🇾' },
        { id: 'SD', name: 'Sudan', code: 'SD', flag: '🇸🇩' },
        { id: 'SS', name: 'South Sudan', code: 'SS', flag: '🇸🇸' },
        { id: 'UG', name: 'Uganda', code: 'UG', flag: '🇺🇬' },
        { id: 'TZ', name: 'Tanzania', code: 'TZ', flag: '🇹🇿' },
        { id: 'RW', name: 'Rwanda', code: 'RW', flag: '🇷🇼' },
        { id: 'BI', name: 'Burundi', code: 'BI', flag: '🇧🇮' },
        { id: 'CD', name: 'Democratic Republic of the Congo', code: 'CD', flag: '🇨🇩' },
        { id: 'CG', name: 'Republic of the Congo', code: 'CG', flag: '🇨🇬' },
        { id: 'CF', name: 'Central African Republic', code: 'CF', flag: '🇨🇫' },
        { id: 'TD', name: 'Chad', code: 'TD', flag: '🇹🇩' },
        { id: 'CM', name: 'Cameroon', code: 'CM', flag: '🇨🇲' },
        { id: 'GQ', name: 'Equatorial Guinea', code: 'GQ', flag: '🇬🇶' },
        { id: 'GA', name: 'Gabon', code: 'GA', flag: '🇬🇦' },
        { id: 'ST', name: 'São Tomé and Príncipe', code: 'ST', flag: '🇸🇹' },
        { id: 'AO', name: 'Angola', code: 'AO', flag: '🇦🇴' },
        { id: 'ZM', name: 'Zambia', code: 'ZM', flag: '🇿🇲' },
        { id: 'ZW', name: 'Zimbabwe', code: 'ZW', flag: '🇿🇼' },
        { id: 'BW', name: 'Botswana', code: 'BW', flag: '🇧🇼' },
        { id: 'NA', name: 'Namibia', code: 'NA', flag: '🇳🇦' },
        { id: 'SZ', name: 'Eswatini', code: 'SZ', flag: '🇸🇿' },
        { id: 'LS', name: 'Lesotho', code: 'LS', flag: '🇱🇸' },
        { id: 'MG', name: 'Madagascar', code: 'MG', flag: '🇲🇬' },
        { id: 'MU', name: 'Mauritius', code: 'MU', flag: '🇲🇺' },
        { id: 'SC', name: 'Seychelles', code: 'SC', flag: '🇸🇨' },
        { id: 'KM', name: 'Comoros', code: 'KM', flag: '🇰🇲' },
        { id: 'DJ', name: 'Djibouti', code: 'DJ', flag: '🇩🇯' },
        { id: 'SO', name: 'Somalia', code: 'SO', flag: '🇸🇴' },
        { id: 'ER', name: 'Eritrea', code: 'ER', flag: '🇪🇷' },
        { id: 'ML', name: 'Mali', code: 'ML', flag: '🇲🇱' },
        { id: 'BF', name: 'Burkina Faso', code: 'BF', flag: '🇧🇫' },
        { id: 'NE', name: 'Niger', code: 'NE', flag: '🇳🇪' },
        { id: 'SN', name: 'Senegal', code: 'SN', flag: '🇸🇳' },
        { id: 'GM', name: 'Gambia', code: 'GM', flag: '🇬🇲' },
        { id: 'GW', name: 'Guinea-Bissau', code: 'GW', flag: '🇬🇼' },
        { id: 'GN', name: 'Guinea', code: 'GN', flag: '🇬🇳' },
        { id: 'SL', name: 'Sierra Leone', code: 'SL', flag: '🇸🇱' },
        { id: 'LR', name: 'Liberia', code: 'LR', flag: '🇱🇷' },
        { id: 'CI', name: 'Ivory Coast', code: 'CI', flag: '🇨🇮' },
        { id: 'TG', name: 'Togo', code: 'TG', flag: '🇹🇬' },
        { id: 'BJ', name: 'Benin', code: 'BJ', flag: '🇧🇯' },
        { id: 'CV', name: 'Cape Verde', code: 'CV', flag: '🇨🇻' },
        { id: 'MR', name: 'Mauritania', code: 'MR', flag: '🇲🇷' },
        { id: 'MW', name: 'Malawi', code: 'MW', flag: '🇲🇼' },
        { id: 'MZ', name: 'Mozambique', code: 'MZ', flag: '🇲🇿' },

        // Oceania
        { id: 'AU', name: 'Australia', code: 'AU', flag: '🇦🇺' },
        { id: 'NZ', name: 'New Zealand', code: 'NZ', flag: '🇳🇿' },
        { id: 'FJ', name: 'Fiji', code: 'FJ', flag: '🇫🇯' },
        { id: 'PG', name: 'Papua New Guinea', code: 'PG', flag: '🇵🇬' },
        { id: 'SB', name: 'Solomon Islands', code: 'SB', flag: '🇸🇧' },
        { id: 'VU', name: 'Vanuatu', code: 'VU', flag: '🇻🇺' },
        { id: 'NC', name: 'New Caledonia', code: 'NC', flag: '🇳🇨' },
        { id: 'PF', name: 'French Polynesia', code: 'PF', flag: '🇵🇫' },
        { id: 'WS', name: 'Samoa', code: 'WS', flag: '🇼🇸' },
        { id: 'TO', name: 'Tonga', code: 'TO', flag: '🇹🇴' },
        { id: 'KI', name: 'Kiribati', code: 'KI', flag: '🇰🇮' },
        { id: 'TV', name: 'Tuvalu', code: 'TV', flag: '🇹🇻' },
        { id: 'NR', name: 'Nauru', code: 'NR', flag: '🇳🇷' },
        { id: 'FM', name: 'Micronesia', code: 'FM', flag: '🇫🇲' },
        { id: 'MH', name: 'Marshall Islands', code: 'MH', flag: '🇲🇭' },
        { id: 'PW', name: 'Palau', code: 'PW', flag: '🇵🇼' },

        // Other
        { id: 'OTHER', name: 'Other', code: 'OTHER', flag: '🌍' }
      ];
